import { Accordion, ActionBar, FormRouteLeavingPrompt } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { HealthcareProviderPatientPortalBindingLoader } from './HealthcareProviderPatientPortalBindingLoader';
import { CurrentHealthcareProviderBoundServiceSection } from './currentHealthcareProviderBoundService/CurrentHealthcareProviderBoundServiceSection';
import { DataForPatientsSection } from './dataForPatients/DataForPatientsSection';
import { HealthcareProviderConfigurationForm } from './form/HealthcareProviderConfigurationForm';
import { HealthcareProviderConfigurationSaveButton } from './form/HealthcareProviderConfigurationSaveButton';
import { HealthcareProviderSettingsSection } from './healthcareProviderPatientPortalSettings/HealthcareProviderSettingsSection';
import { PreInterviewSettingsSection } from './preInterviewSettings/PreInterviewSettingsSection';

const sectionIds = {
   preInterviewSettings: 'preInterviewSettings',
   appointmentRequestsSettings: 'appointmentRequestsSettings',
   dataForPatients: 'dataForPatients',
   boundServices: 'boundServices',
};

export const HealthcareProviderPatientPortalPanel = (): JSX.Element => {
   return (
      <HealthcareProviderPatientPortalBindingLoader>
         {({
            healthcareProviderPatientPortalBinding,
            healthcareProviderConfiguration,
            healthcareProviderEmailAddress,
         }) => (
            <HealthcareProviderConfigurationForm
               configuration={healthcareProviderConfiguration}
               defaultAppointmentRequestsEmail={healthcareProviderEmailAddress}
            >
               {({ register, watch, handleSubmit, formState }) => (
                  <ActionBar
                     id={'healthcare-provider-patient-portal-action-bar'}
                     testId={'healthcareProviderPatientPortal'}
                  >
                     <Accordion
                        testId={'healthcareProviderPatientPortal'}
                        allowOpenMultipleSections
                        defaultOpenedSectionsIds={Object.values(sectionIds)}
                     >
                        {/* TODO DRPAC-1375 Zdjęcie flagi eksperymentalnej z konfiguracji prewywiadu */}
                        {protectFeature(
                           'experimental',
                           <PreInterviewSettingsSection
                              id={sectionIds.preInterviewSettings}
                              register={register}
                              watch={watch}
                           />,
                           <></>
                        )}
                        <HealthcareProviderSettingsSection
                           id={sectionIds.appointmentRequestsSettings}
                           register={register}
                           watch={watch}
                           defaultAppointmentRequestsEmail={healthcareProviderEmailAddress}
                        />
                        <DataForPatientsSection
                           id={sectionIds.dataForPatients}
                           healthcareProviderCode={healthcareProviderPatientPortalBinding.code}
                           patientPortalUrl={healthcareProviderPatientPortalBinding.url}
                        />
                        <CurrentHealthcareProviderBoundServiceSection id={sectionIds.boundServices} />
                     </Accordion>
                     <HealthcareProviderConfigurationSaveButton handleSubmit={handleSubmit} />
                     <FormRouteLeavingPrompt formState={formState} />
                  </ActionBar>
               )}
            </HealthcareProviderConfigurationForm>
         )}
      </HealthcareProviderPatientPortalBindingLoader>
   );
};
